import { render, staticRenderFns } from "./textColorPicker.vue?vue&type=template&id=50ad1e21&scoped=true"
import script from "./textColorPicker.vue?vue&type=script&lang=js"
export * from "./textColorPicker.vue?vue&type=script&lang=js"
import style0 from "./textColorPicker.vue?vue&type=style&index=0&id=50ad1e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad1e21",
  null
  
)

export default component.exports